"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function asList(a) {
  if ($.isArray(a)) return a;else if ($.type(a) === "null" || $.type(a) === "undefined") return [];else return [a];
}

function asNilable(a) {
  if ($.isPlainObject(a)) return null;else if ($.type(a) === "null" || $.type(a) === "undefined") return null;else return a;
}

var InterviewRun = new JS.Class({
  interview: null,
  timeStarted: null,
  timeFinished: null,
  uuid: null,
  answers: null,
  savedOK: false,
  saveErrors: null,
  patientId: null,
  scheduleStatus: null,
  completionStatus: null,
  expectedFinish: null,
  schedId: null,

  initialize: function initialize(interview, patientId, scheduleIdStr, expectedFinish, schedId) {
    this.interview = interview;
    this.patientId = patientId;
    this.scheduleIdStr = scheduleIdStr;
    this.expectedFinish = expectedFinish == "" ? null : moment(expectedFinish).toDate();
    this.uuid = UUID.generate();
    this.saveErrors = [];
    this.schedId = schedId;
  },

  start: function start() {
    var self = this;
    startLoadingSpinner();
    setTimeout(function () {
      self.doStart();
      stopLoadingSpinner();
    }, 400);
  },

  doStart: function doStart() {
    this.answers = [];
    this.timeStarted = new Date();
    this.completionStatus = null;

    if (!inBrowser) {
      BLE_CONTROL.clearTempReadings();
    }

    if (this.scheduleIdStr == "none") this.scheduleStatus = "unscheduled";else this.scheduleStatus = "on-schedule";

    this.interview.makePages();
    this.interview.start(this);
  },

  timedOut: function timedOut() {
    this.completionStatus = "timed_out";
    this.finish();
  },

  exit: function exit() {
    this.completionStatus = "completed";
    this.finish();
  },

  finish: function finish() {
    this.timeFinished = new Date();
    if (this.scheduleStatus == "on-schedule" && this.expectedFinish && this.timeFinished > this.expectedFinish) {
      this.scheduleStatus = "outside-schedule";
    }
    this.save();
  },

  save: function save() {
    var self = this;
    Store.save(this.toJson()).then(function () {
      self.savedOK = true;

      var endMessage = $t("interviews.interview_complete");
      var showEndDialog = false;
      if (Auth.offline()) {
        endMessage = $t("interviews.interview_complete_signed_out");
      } else if (self.scheduleStatus == "unscheduled") {
        endMessage = $t("interviews.interview_complete_unscheduled");
        showEndDialog = self.completionStatus != "timed_out";
      }

      if (mymobileConfig.speakInterviews) {
        Speak.continue(endMessage);
      }

      if (showEndDialog && mymobileConfig.unscheduled_interview_warning) {
        alert(endMessage);
      }

      if (!inBrowser) {
        BLE_CONTROL.confirmTempReadings(function (result) {
          console.log("Confirmed temporary readings.");
          console.log(result);
        }, function (error) {
          console.error("Could not confirm temporary readings.");
          console.error(error);
        });
      }

      if (self.scheduleIdStr) {
        Interviews.saveCompletedTimes(self.interview.id, { title: self.interview.title,
          timeFinished: self.timeFinished,
          timeStarted: self.timeStarted,
          scheduleIdStr: self.scheduleIdStr });
      }
    }).fail(function (errorObject) {
      self.savedOK = false;
      self.saveErrors.push(errorObject.msg);
    });
  },

  addChoice: function addChoice(choice) {
    this.answers.push({ stepId: choice.step.json.id, choiceId: choice.json.id, time: new Date() });
  },

  addVitals: function addVitals(step, vitals, retake, sensorId, date, batteryStatus, checksum, deferred) {
    console.log("Saving Vitals");
    var answers = this.answers;
    if (checksum && sensorId) {
      var sensor = Profile.getSensorByTMId(sensorId);
      BLE_CONTROL.saveTempReading(sensor.device.device_uuid, checksum, date, function (result) {
        console.log("Saved temp reading in device DB: " + sensor.device.device_uuid + " " + checksum);
        answers.push({ stepId: step.json.id, vitals: vitals, retake: retake, time: date, batteryStatus: batteryStatus, sensorId: sensorId });
        if (deferred) {
          deferred.resolve();
        }
      }, function (error) {
        console.error("Could not save confirmation of reading: ");
        console.error(error);
        if (deferred) {
          deferred.reject();
        }
      });
    } else {
      answers.push({ stepId: step.json.id, vitals: vitals, retake: retake, time: date, batteryStatus: batteryStatus, sensorId: sensorId });
      if (deferred) {
        deferred.resolve();
      }
    }
  },

  toJson: function toJson() {
    var xml = this.makeXML();
    var encryptedXml = encrypt(xml);

    return {
      jsonVersion: 1,
      title: this.interview.title,
      interviewId: this.interview.id,
      timeStarted: this.timeStarted,
      timeFinished: this.timeFinished,
      uuid: this.uuid,
      patientId: this.patientId,
      schedId: this.schedId,
      syncStatus: 'pending',
      xml: encryptedXml };
  },

  // <?xml version="1.0" encoding="UTF-8"?>
  // <interview-data sha256="#{@sha}">
  //   <interview-id>#{@i.id}</interview-id>
  //   <completedDateTimeUTC>1337887495894</completedDateTimeUTC>
  //   <patient-id>#{@p.id}</patient-id>
  //   <hub-token>702DF47A762CCC45DB9F0AE3F972FBE70D9BD43B3595FB56120D3479BD67F723</hub-token>
  //   <answer step-id="#{@q.id}" choice-id="#{@q.choices.first.id}"/>

  //   <reading step-id="#{@s.id}" timeUTC="1337887451046">
  //     <!-- <measurement type="bg" unit="mmol/L" value="14" designation="fake-designation"/> -->
  //     <measurement type="#{@m.name}" value="126" unit="#{@u.name}"/>
  //   </reading>
  // </interview-data>

  makeXML: function makeXML() {
    var b = new XMLBuilder();

    b.root("interview-data").add("interview-id", this.interview.id).add("monitor-schedule-id", this.schedId).add("completedDateTimeUTC", b.date(this.timeFinished)).add("patient-id", this.patientId).add("hub-token", "").add('guid', this.uuid).add('completion-status', this.completionStatus) // completed timed_out interrupted
    .add('schedule-status', this.scheduleStatus); //  unscheduled_or_outside unscheduled outside_schedule on_schedule


    for (var i = 0; i < this.answers.length; i++) {
      var answer = this.answers[i];
      if (answer.choiceId !== undefined) {
        b.add(b.element("answer", { "step-id": answer.stepId, "choice-id": answer.choiceId }));
      }
    }

    for (var i = 0; i < this.answers.length; i++) {
      var answer = this.answers[i];
      if (answer.vitals !== undefined) {
        var measurements = [];
        for (var vitalName in answer.vitals) {

          var sensorId = answer.sensorId;

          if (sensorId) {
            var sensor = Profile.getSensorByTMId(answer.sensorId);
          }

          if (sensor && sensor.device.collectsBinaryData) {
            var val = ByteArrayConverter.byteArrayToBase64(answer.vitals[vitalName].value);
          } else {
            var val = answer.vitals[vitalName].value;
            val = $.trim(val);
            val = val.replace(",", "."); // for locales with , decimal separator
          }

          var designations = answer.vitals[vitalName].designations;
          var unit = answer.vitals[vitalName].unit;

          var desigList = [];
          if (typeof designations != 'string') {
            _.each(designations, function (designation) {
              if ((typeof designation === "undefined" ? "undefined" : _typeof(designation)) == 'object') {
                desigList.push(b.container("designation", [b.text("type", designation.type), b.text("name", designation.name)]));
              }
            });
            measurements.push(b.container("measurement", desigList, { "type": vitalName, "unit": answer.vitals[vitalName].unit, "value": val }));
          } else {
            measurements.push(b.container("measurement", desigList, { "type": vitalName, "unit": answer.vitals[vitalName].unit, "value": val, "designation": designations }));
          }
        }

        b.add(b.container("reading", measurements, { "step-id": answer.stepId, "timeUTC": b.date(answer.time),
          "keep": true, "retake": answer.retake, "sensor-id": answer.sensorId,
          "battery-status": answer.batteryStatus }));
      }
    }
    return '<?xml version="1.0" encoding="UTF-8"?>' + b.toString();
  },

  makeXML31: function makeXML31() {
    var b = new XMLBuilder();
    b.root("interview-data", { "xmlns": "Tunstall-#3.1-Client",
      "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
      "xsi:schemaLocation": "interview-data-3.1.xsd" }).add('guid', this.uuid).add('monitor-schedule-id', this.schedId).add(b.container("interview", [b.text("interview-id", this.interview.id), b.text("interview-version", 'abcdef0123456789ABCDEF0123456789')])).add('patient-id', this.patientId).add('completion-status', 'completed') // timed_out interrupted
    .add('schedule-status', this.scheduleStatus) //  unscheduled_or_outside unscheduled outside_schedule on_schedule
    .add('completed', b.date(this.timeFinished));

    for (var i = 0; i < this.answers.length; i++) {
      var answer = this.answers[i];
      if (answer.choiceId !== undefined) {
        b.add(b.container("answer", [b.text("step-id", answer.stepId), b.text("choice-id", answer.choiceId)]));
      }
    }

    for (var i = 0; i < this.answers.length; i++) {
      var skipped = true;
      var answer = this.answers[i];
      if (answer.vitals !== undefined) {
        var readings = [b.text("time", b.date(answer.time))];
        for (var vitalName in answer.vitals) {
          var val = answer.vitals[vitalName].value;
          var designations = answer.vitals[vitalName].designations;
          val = $.trim(val);
          if (val != "") {
            skipped = false;
            var mList = [b.text("measurement-type-id", vitalName), b.text("value", val), b.text("unit", answer.vitals[vitalName].unit), b.text("sensor-id", answer.vitals[vitalName].sensorId)];

            _.each(designations, function (designation) {
              mList.push(b.container("designation", [b.text("type", designation.type), b.text("name", designation.name)]));
            });

            readings.push(b.container("measurement", mList));
          }
        }

        if (readings.length > 1) {
          var reading = b.container("reading", readings, { index: 1 });
          var transfer;
          if (skipped == false) {
            transfer = b.container("transfer", [reading], { index: 1 });
          } else {
            transfer = b.container("skipped");
          }

          b.add(b.container("peripheral-data", [b.text("step-id", answer.stepId), b.text("peripheral-id", '0'), b.text("peripheral-type-id", ""), transfer]));
        } else {
          transfer = b.container("skipped");
          b.add(b.container("peripheral-data", [b.text("step-id", answer.stepId), b.text("peripheral-id", '0'), b.text("peripheral-type-id", ""), transfer]));
        }
      }
    }
    return '<?xml version="1.0" encoding="UTF-8"?>' + b.toString();
  }
});

var Interview = new JS.Class({
  title: "",
  steps: null,
  groups: null,
  json: null,
  position: null,
  id: null,
  loaded: false,

  initialize: function initialize(interviewJson, position) {
    this.position = position;
    this.json = interviewJson;
    this.title = this.json.name;
    this.id = this.json.id;
    this.version = this.json['revision-number'];
    this.steps = [];
    this.groups = {};
    this.schedules = [];
    this.nextDate = null;
    this.endStep = null;
    this.endStepTimeOut = 5;
    this.repeated = {};
    var endStepTimeOut = this.json['end-step-timeout'];

    if ($.isNumeric(endStepTimeOut)) {
      this.endStepTimeOut = parseInt(endStepTimeOut);
    }

    if (this.json.groups) {
      var groupList = asList(this.json.groups['step-group']);
      for (var i = 0; i < groupList.length; i++) {
        this.groups[groupList[i].id] = groupList[i];
      }
    }

    var rsteps = asList(this.json.steps['rating-step']);
    for (var i = 0; i < rsteps.length; i++) {
      this.steps.push(new RatingStep(this, rsteps[i]));
    }
    var qsteps = asList(this.json.steps['question-step']);
    for (var i = 0; i < qsteps.length; i++) {
      this.steps.push(new QuestionStep(this, qsteps[i]));
    }
    var tsteps = asList(this.json.steps['text-step']);
    for (var i = 0; i < tsteps.length; i++) {
      this.steps.push(new TextStep(this, tsteps[i]));
    }
    var ssteps = asList(this.json.steps['sensor-step']);
    for (var i = 0; i < ssteps.length; i++) {
      this.steps.push(new SensorStep(this, ssteps[i]));
    }
    var esteps = asList(this.json.steps['end-step']);
    for (var i = 0; i < esteps.length; i++) {
      this.endStep = new EndStep(this, esteps[i]);
      this.steps.push(this.endStep);
    }
    this.steps = this.steps.sort(function (a, b) {
      return a.position - b.position;
    });
  },

  compareBySchedule: function compareBySchedule(other) {
    if (this.nextDate != null && other.nextDate != null) {
      if (this.doneToday == other.doneToday) {
        return this.nextDate.reminderStart - other.nextDate.reminderStart;
      } else if (this.doneToday) {
        return 1;
      } else {
        return -1;
      }
    } else if (this.nextDate != null) {
      return -1;
    } else if (other.nextDate != null) {
      return 1;
    } else {
      return this.title - other.title;
    }
  },

  addSchedule: function addSchedule(sched) {
    this.schedules.push(sched);
  },

  start: function start(interviewRun) {
    this.repeated = {};
    this.interviewRun = interviewRun;

    if (this.steps.length == 0) {
      this.goToPage("#q_exit_no_save");
      return;
    }

    $(".vitals-input").val("");
    $(".vitals-input-error").text("").hide();
    $(".choice-input").prop('checked', false);
    $(".ui-radio .choice-input").checkboxradio('refresh'); // page inited
    $(".designation-input").prop('selectedIndex', 0);
    $(".ui-btn select.designation-input").selectmenu('refresh'); // page inited
    $(".question-next").hide();
    $(".sensor-confirm").hide();

    //Skip the first steps if restricted sensor steps
    var firstStepIndex = 0;
    var firstStep = this.steps[firstStepIndex];

    while (firstStep.sensorType && Profile.hasSensorTypeRestriction(firstStep.sensorType)) {
      firstStepIndex++;

      if (firstStepIndex >= this.steps.length) {
        console.error("Interview consists only of restricted sensor steps. Check TM patient configuration.");
        this.goToPage("#q_exit_no_save");
        return;
      }

      firstStep = this.steps[firstStepIndex];
    }

    this.stepHistory = [];

    this.goToPage("#" + firstStep.pageId());
  },

  hasSensorStep: function hasSensorStep() {
    var step;
    for (var i = 0; i < this.steps.length; i++) {
      step = this.steps[i];
      if (step.sensorType) {
        return true;
      }
    }
    return false;
  },

  end: function end() {
    this.interviewRun = null;
    this.loaded = false;
    this.removePages();
  },

  isRunning: function isRunning() {
    return !!this.interviewRun;
  },

  removePages: function removePages() {
    $(".step-content-para").remove();
    $(".ui-radio .choice-input").checkboxradio('destroy'); // page inited
    $(".ui-btn select.designation-input").selectmenu('destroy'); // page inited
    $(".rippleria-ink").remove();

    for (var i = 0; i < this.steps.length; i++) {
      this.steps[i].removePage();
    }
  },

  makePages: function makePages() {
    if (!this.loaded) {
      this.loaded = true;
      for (var i = 0; i < this.steps.length; i++) {
        var page = $(this.steps[i].makePage());

        page.appendTo($.mobile.pageContainer).trigger('create');
        addLongTap(page[0]);
        addRipple($("[data-rippleria]", page[0]));
        this.setupRatings(page.get(), this.steps[i]);
      }

      // replace \n with <p>
      $(".interview-content").each(function () {
        var elem = $(this);
        var paras = elem.text().split('\n');
        if (paras.length > 0) {
          elem.empty();

          _.each(paras, function (paraText) {
            var para;
            if ($.trim(paraText) == "") para = $("<p>&nbsp;</p>");else para = $("<p>").text(paraText);
            elem.append(para.addClass('step-content-para'));
          });
        }
      });
    }
  },

  updateSliderText: function updateSliderText(elem, step) {
    // make sure val isn't larger than the max allowed
    var val = $(elem).val();
    if (val != "") {
      var index = parseInt(val) - 1;
      var choice = step.choices[index];
      if (!choice) {
        if (index == 0) {
          $(elem).val(1);
        } else {
          $(elem).val(step.choices.length);
        }
      }
    }

    // update ratingDisplay 
    var control = $(elem).closest(".rating-control");
    var ratingDisplay = control.find('.br-current-rating');

    if (step.mode == "standard") {
      var val = $(elem).val();
      if (val != "") {
        var index = parseInt(val) - 1;
        var choice = step.choices[index];
        var displayText = choice.json.text;
        ratingDisplay.width('100%');
        ratingDisplay.css({ 'text-align': 'center', 'padding-left': "0px", height: '24px' });
        ratingDisplay.text(displayText);
      }
    } else {
      ratingDisplay.hide();
    }
  },

  updateSlider: function updateSlider(elem) {
    var control = $(elem).closest(".rating-control");

    var val = $(elem).val();
    if (val != "") {
      val = parseInt(val) - 1;
      control.attr('data-choice-position', val);
    }
    var ipos = parseInt(control.attr("data-interview-position"));
    var spos = parseInt(control.attr("data-step-position"));
    Interviews.choiceClicked(elem, ipos, spos, true);
  },

  setupRatings: function setupRatings(page, step) {
    var self = this;

    $("input.slider", page).slider({
      highlight: true,
      drag: function drag(event, ui) {
        self.updateSliderText(this, step);
      },
      stop: function stop(event, ui) {
        self.updateSliderText(this, step);
        self.updateSlider(this);
      }
    });

    if (step.mode == "endpoints_only" && step.useSlider) {
      $(".br-title-container", page).addClass("br-title-container-indent");
    }

    $("input.slider", page).on("input change", function () {
      self.updateSliderText(this, step);
      self.updateSlider(this);
    }).blur(function () {
      var control = $(this).closest(".rating-control");

      var val = $(this).val();
      if (val == "") {
        val = control.attr('data-choice-position');
        if (!val || val == "") {
          val = 1;
        } else {
          val = parseInt(val) + 1;
        }
        $(this).val(val);
        self.updateSliderText(this, step);
        self.updateSlider(this);
      }
    });

    $("input[data-rating-icon]", page).each(function () {
      var icon = $(this).attr("data-rating-icon");
      if (icon != "") {
        var radio = $(this).closest(".ui-radio");
        $(radio).addClass("radio-with-icon");
        var label = $("label", radio[0]);
        var imagePath = localFilePath('/images/ratings/' + icon.replace("icon_set", "set") + '.png');
        $(label).css({ "background-image": 'url("' + imagePath + '")' });
      }
    });

    var baseRatingOpts = {
      showValues: true,
      showSelectedRating: false,
      initialRating: null,
      onSelect: function onSelect(value, text, elem) {

        var control = $(elem).closest(".rating-control");
        var ipos = parseInt(control.attr("data-interview-position"));
        var spos = parseInt(control.attr("data-step-position"));
        control.attr('data-choice-position', value);
        Interviews.choiceClicked(elem, ipos, spos, true);
      }
    };

    $('.number-only-rating.use-icons', page).barrating('show', $.extend({}, baseRatingOpts, { useIcons: true, wrapperClasses: ['br-wrapper-c', 'br-wrapper-with-icon'] }));
    $('.number-only-rating.max-or-under', page).barrating('show', $.extend({}, baseRatingOpts, { wrapperClasses: ['br-wrapper-c'] }));
    $('.number-only-rating.over-max', page).barrating('show', $.extend({}, baseRatingOpts, { showSelectedRating: true, showValues: false, wrapperClasses: ['br-wrapper'] }));

    baseRatingOpts.showSelectedRating = true;
    $('.number-and-text-rating.use-icons', page).barrating('show', $.extend({}, baseRatingOpts, { useIcons: true, wrapperClasses: ['br-wrapper-c', 'br-wrapper-with-icon'] }));
    $('.number-and-text-rating.max-or-under', page).barrating('show', $.extend({}, baseRatingOpts, { wrapperClasses: ['br-wrapper-c'] }));
    $('.number-and-text-rating.over-max', page).barrating('show', $.extend({}, baseRatingOpts, { showValues: false, wrapperClasses: ['br-wrapper'] }));

    Interviews.adjustRatingLayout(page);
  },

  nextClicked: function nextClicked(stepPos) {
    var step = this.steps[stepPos];
    this.goToPage(step.nextStep());
  },

  retakeClicked: function retakeClicked(stepPos) {
    var step = this.steps[stepPos];
    this.goToPage(step.nextRetake());
  },

  goBackOneStep: function goBackOneStep() {
    this.stepHistory.pop();
    this.goToPage(this.stepHistory.pop());
  },

  goToPage: function goToPage(pageId) {
    var self = this;
    Interviews.stopAllBluetooth();

    var exit = pageId == "#q_exit" || pageId == "#q_exit_no_save" || this.endStep != null && pageId == this.endStep.pageIdRef();
    if (exit) {
      if (pageId != "#q_exit_no_save") {
        this.interviewRun.exit();
        MainPage.syncNextLoad = true;
      }

      if (this.endStep == null || pageId == "#q_exit_no_save") {
        this.end();
        openPage("#main");
      } else {
        openPage(this.endStep.pageIdRef());
        setTimeout(function () {
          self.end();
          openPage("#main");
        }, this.endStepTimeOut * 1000);
      }
    } else {

      if (this.stepHistory[this.stepHistory.length - 1] != pageId) {
        this.stepHistory.push(pageId);
      }

      openPage(pageId);
    }
  },

  choiceNextClicked: function choiceNextClicked(stepPos, choicePos) {
    var step = this.steps[stepPos];
    var choice = step.choices[choicePos];
    this.interviewRun.addChoice(choice);
    var self = this;
    if (mymobileConfig.confirmAnswers) self.goToPage(choice.nextStep());else setTimeout(function () {
      self.goToPage(choice.nextStep());
    }, 1000);
  },

  vitalsNextClicked: function vitalsNextClicked(stepPos) {
    //Sometimes we have a single step but the position is not 0.
    var step; // = this.steps[stepPos];
    for (var i = 0; i < this.steps.length; i++) {
      step = this.steps[i];
      if (step.position == stepPos) {
        break;
      }
    }
    if (step) {
      this.goToPage(step.nextStep());
    }
  },

  saveVitals: function saveVitals(stepPos, vitals, retake, sensorId, date, batteryStatus, checksum, deferred) {

    //Sometimes we have a single step but the position is not 0.
    var step; // = this.steps[stepPos];
    for (var i = 0; i < this.steps.length; i++) {
      step = this.steps[i];
      if (step.position == stepPos) {
        break;
      }
    }

    var vitalData = {};
    for (var i = 0; i < vitals.length; i++) {
      var vital = vitals[i];

      if (vital.name) {
        var name = vital.name;
      } else if (step.vitals[vital.vitalPos]) {
        var vitalDefinition = step.vitals[vital.vitalPos];
        var name = vitalDefinition.json.name;
      } else {
        var name = 'ecg_data';
      }

      var data = {};
      data.designations = vital.designations;
      if (vital.sensorValue != null) {
        data.value = vital.sensorValue;
        data.unit = vital.sensorUnit;
      } else {
        data.value = vital.vitalVal;
        data.unit = vitalDefinition.json.unit_name;
      }
      if (vital.date) {
        data.date = vital.date;
      }
      vitalData[name] = data;
    }
    this.interviewRun.addVitals(step, vitalData, retake, sensorId, date, batteryStatus, checksum, deferred);
  }

});

var StepContentLink = new JS.Class({
  id: null,
  label: null,
  url: null,
  type_name: null,

  initialize: function initialize(step, json) {
    this.id = parseInt(json['id']);
    this.label = json['label'];
    this.url = json['url'];
    this.type_name = json['type_name'];
    this.icon_name = this.type_name == "video" ? "video" : "notepad";
  },

  makeUrl: function makeUrl() {
    var url = this.url;
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "http://" + url;
    }
    return url;
  }

});

var Step = new JS.Class({
  json: null,
  position: null,
  interview: null,
  links: null,

  initialize: function initialize(interview, stepJson) {
    debugger;
    this.interview = interview;
    this.json = stepJson;
    this.position = parseInt(stepJson.position);

    this.links = [];
    var _this = this;
    if (stepJson["links"] && stepJson["links"] != "") {
      var linkList = asList(stepJson["links"]["link"]);
      linkList.forEach(function (linkJson) {
        _this.links.push(new StepContentLink(_this.id, linkJson));
      });
    }
  },

  pageId: function pageId() {
    return "q__" + this.interview.id + "__" + this.json.position;
  },

  pageIdRef: function pageIdRef() {
    return this.pageIdRefFromPosition(this.position);
  },

  pageIdRefFromPosition: function pageIdRefFromPosition(position) {
    return "#q__" + this.interview.id + "__" + position;
  },

  isLastStep: function isLastStep() {
    return this.position + 1 >= this.interview.steps.length;
  },

  nextStep: function nextStep() {
    return this.jumpTo(this.json['jump-to']);
  },
  nextRetake: function nextRetake() {
    return this.jumpTo(this.json['retake-jump-to']);
  },
  jumpTo: function jumpTo(destination) {
    if (destination == "-1") {
      if (this.isLastStep()) {
        return "#q_exit";
      } else {
        var nextStepIndex = parseInt(this.position + 1);
        var nextStep = this.interview.steps[nextStepIndex];
        while (nextStep && nextStep.sensorType && Profile.hasSensorTypeRestriction(nextStep.sensorType)) {
          nextStepIndex++;
          nextStep = this.interview.steps[nextStepIndex];
        }

        if (nextStepIndex >= this.interview.steps.length) {
          return "#q_exit";
        } else {
          return this.pageIdRefFromPosition(nextStepIndex);
        }
      }
    } else if (destination == "exit") {
      return "#q_exit";
    } else {
      return this.pageIdRefFromPosition(destination);
    }
  },

  removePage: function removePage() {
    $("#" + this.pageId()).trigger('destroy').remove();
    $("#popupSkipConfirm-" + this.pageId() + "-screen").remove();
    $("#popupSkipConfirm-" + this.pageId() + "-popup").remove();
    $("#popupBluetoothDisabled-" + this.pageId() + "-screen").remove();
    $("#popupBluetoothDisabled-" + this.pageId() + "-popup").remove();
    $("#popupBasic-" + this.pageId() + "-screen").remove();
    $("#popupBasic-" + this.pageId() + "-popup").remove();
  },

  makePage: function makePage() {
    var params = {
      pageId: this.pageId(),
      stepId: this.json.id,
      pageTitle: $t("app.name"),
      dataTheme: "f", //gTheme.letter,
      title: this.interview.title,
      interviewPosition: this.interview.position,
      stepPosition: this.position,
      content: this.json.content,
      retake: this.json["retake-jump-to"],
      greater: null,
      less: null,
      backButton: this.position > 0,
      homeButton: true,
      volumeButton: mymobileConfig.speakInterviews,
      volumeState: Store.getVolume(),
      sensorType: this.sensorType,
      links: this.links
    };

    var group = this.interview.groups[this.json['step-group-id']];
    if (group && group.content) {
      params.group_content = group.content;
    }

    this.addPageContent(params);

    var html = applyI18nAttrs(ich.t_interviewPage(params));

    $('.input-switch-button-automatic', html).bind("click", function (event) {
      Interviews.toggleInputMode($(this), 'auto');
    });
    $('.input-switch-button-manual', html).bind("click", function (event) {
      Interviews.toggleInputMode($(this), 'manual');
    });

    $('.sensor-manual-retake', html).hide();

    var sensor = Profile.getSensorByType(this.sensorType);
    if (!inBrowser && sensor && sensor.device) {
      Interviews.setSensor(html, sensor);
      Interviews.showSensorInputs(html, sensor.device.allowManual());
      this.inputMode = "sensor";
    } else {
      Interviews.showManualInputs(html);
      $('.input-mode-switch-container', html).hide();
      this.inputMode = "manual";
    }

    return html;
  },

  onShow: function onShow() {
    this.speakContent();
  },

  speakContent: function speakContent() {
    if (mymobileConfig.speakInterviews) {
      Speak.interrupt(this.json.content);
    }
  }
});

var QuestionStep = new JS.Class(Step, {

  initialize: function initialize(interview, stepJson) {
    this.callSuper();
    this.choices = [];
    var choiceList = asList(this.json.choices.choice);
    for (var j = 0; j < choiceList.length; j++) {
      this.choices.push(new Choice(this, choiceList[j]));
    }
  },

  addPageContent: function addPageContent(pageParams) {
    var choices = [];
    for (var j = 0; j < this.choices.length; j++) {
      choices.push(this.choices[j].choiceTemplate());
    }
    pageParams.question = {
      choices: choices
    };
  }
});

var RatingStep = new JS.Class(QuestionStep, {

  addPageContent: function addPageContent(pageParams) {
    var choices = [];
    var sliderCutoff = 16;

    for (var j = 0; j < this.choices.length; j++) {
      choices.push(this.choices[j].choiceTemplate());
    }

    var mode = RatingStep.DISPLAY_MODES[parseInt(this.json["display-mode"])];

    if (mode == null) {
      mode = "standard";
    }

    this.mode = mode;
    var max = this.choices.length;
    this.useSlider = this.choices.length > sliderCutoff;
    var sizeClass = this.useSlider ? "over-max" : "max-or-under";

    if (this.choices.length <= sliderCutoff && choices[0].choiceIcon != "") {
      sizeClass = "use-icons";
    }

    pageParams.flexClass = '';
    if (mode == "endpoints_only" || mode == "numbers_only" || mode == "standard") {
      pageParams.flexClass = "flex-choices";
    }

    var mode_opts = {
      choices: choices,
      max: max,
      sizeClass: sizeClass
    };

    var opts = {};

    if (mode == "endpoints_only") {
      mode = "numbers_only";
      opts.lowEndpoint = { text: choices[0].choiceLabel };
      opts.highEndpoint = { text: choices[choices.length - 1].choiceLabel };
    }

    if ((mode == "endpoints_only" || mode == "numbers_only" || mode == "standard") && max > 16) {
      mode = "big_numbers_only";
      mode_opts.sizeClass = "";
    }

    opts[mode] = mode_opts;
    pageParams.ratingDisplayMode = this.mode;
    pageParams.rating = opts;
  },

  speakContent: function speakContent() {
    if (mymobileConfig.speakInterviews) {
      var group = this.interview.groups[this.json['step-group-id']];
      if (group && group.content) {
        Speak.interrupt(group.content);
        Speak.continue(this.json.content);
      } else {
        Speak.interrupt(this.json.content);
      }
    }
  }

});

RatingStep.DISPLAY_MODES = ["standard", "numbers_only", "text_only", "endpoints_only"];

var TextStep = new JS.Class(Step, {
  addPageContent: function addPageContent(pageParams) {
    pageParams.text = {};
  }
});

var EndStep = new JS.Class(TextStep, {
  addPageContent: function addPageContent(pageParams) {
    pageParams.backButton = false;
    pageParams.end = {};
    pageParams.homeButton = false;
  }
});

var SensorStep = new JS.Class(Step, {

  initialize: function initialize(interview, stepJson) {
    this.callSuper();
    this.vitals = [];
    var fieldList = asList(this.json.fields.field);
    this.sensorType = this.json.sensor_type;
    fieldList = this.sortSensorFields(fieldList, this.sensorType);

    for (var k = 0; k < fieldList.length; k++) {
      this.vitals.push(new Vital(this, fieldList[k], k));
    }
  },

  sortSensorFields: function sortSensorFields(fieldList, sensorType) {

    var fieldOrder = {
      "OX": { so2: 1, hr: 2 },
      "BPC": { sbp: 1, dbp: 2, hr: 3 }
    };

    if (!(sensorType in fieldOrder)) {
      return fieldList;
    }

    var sortOrder = fieldOrder[sensorType];

    var cmpFunc = function cmpFunc(a, b) {
      var aVal = a.name in sortOrder ? sortOrder[a.name] : 999;
      var bVal = b.name in sortOrder ? sortOrder[b.name] : 999;
      return aVal - bVal;
    };

    return fieldList.sort(cmpFunc);
  },

  onShow: function onShow() {
    this.speakContent();
    this.startSensorReadings();
  },

  startSensorReadings: function startSensorReadings() {
    if (this.inputMode = "sensor") {
      var parentDiv = $(".ui-content", $("#" + this.pageId()));
      var sensorDiv = $('.automatic-sensor-control', parentDiv);
      Interviews.startSensorReadings($(sensorDiv));
    }
  },

  getVitalByName: function getVitalByName(name) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.vitals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var vital = _step.value;

        if (vital.name == name) {
          return vital;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  },

  addPageContent: function addPageContent(pageParams) {
    var fields = [];
    for (var j = 0; j < this.vitals.length; j++) {
      fields.push(this.vitals[j].fieldTemplate());
      var name = this.vitals[j].json.name;
      var retakeLimits = Profile.findRetake(name);
      if (retakeLimits != null) {
        pageParams.greater = retakeLimits.greater;
        pageParams.less = retakeLimits.less;
      }
    }
    pageParams.sensor = {
      pageId: pageParams.pageId,
      fields: fields
    };
  },

  speakContent: function speakContent() {
    if (mymobileConfig.speakInterviews) {
      Speak.interrupt(this.json.content);
      if (this.inputMode == "manual") {
        Speak.continue($t("interviews.manual_warning"));
      }
    }
  },

  speakReading: function speakReading(measurement, displayVal, bp) {
    if (mymobileConfig.speakInterviews) {

      if (measurement.name == "sbp" || measurement.name == "dbp") {
        bp[measurement.name] = displayVal;

        if (bp.sbp && bp.dbp) {
          var readingMess = $t("sensors.speak_reading_bp").replace("{{sbp}}", "" + bp.sbp).replace("{{dbp}}", "" + bp.dbp);

          Speak.continue(readingMess, 1000);
        }
      } else {
        var vital = this.getVitalByName(measurement.name);
        var _readingMess = $t("sensors.speak_reading").replace("{{name}}", "" + Speak.subVitals(vital.label)).replace("{{value}}", "" + displayVal).replace("{{unit}}", "" + Speak.subUnits(vital.display_unit));

        Speak.continue(_readingMess, 1000);
      }
    }
  }

});

var Vital = new JS.Class({

  initialize: function initialize(step, fieldJson, k) {
    this.step = step;
    this.json = fieldJson;
    this.name = fieldJson.name;

    this.label = fieldJson.description;
    if (!this.label || this.label == "") {
      this.label = fieldJson.label;
    }
    if (!this.label || this.label == "") {
      this.label = fieldJson.text.replace(/ \(.*\)/, "");
    }

    this.unitName = fieldJson.unit_name;
    this.display_unit = fieldJson.display_unit;
    if (!this.display_unit || this.display_unit == "") {
      this.display_unit = fieldJson.unit_name;
    }

    this.position = k;
    this.designationTypes = [];
    var desigTypeList = this.json['designation-types'] ? asList(this.json['designation-types']['designation-type']) : [];
    for (var k = 0; k < desigTypeList.length; k++) {
      var name = desigTypeList[k].name;
      var omitList = mymobileConfig.omitDesignations;
      if (!omitList) omitList = [];
      if (omitList.indexOf(name) == -1) this.designationTypes.push(new DesignationType(this, desigTypeList[k], k));
    }
  },

  fieldTemplate: function fieldTemplate() {
    var greater, less;

    var id = this.step.pageId() + "__f__" + this.position;
    var decimal_places = 2;
    if (this.json.decimal_places !== undefined) decimal_places = parseInt(this.json.decimal_places);

    var designationTypeTemplates = [];
    _.each(this.designationTypes, function (designationType) {
      designationTypeTemplates.push(designationType.template());
    });

    var retake = Profile.findRetake(this.json.name);

    if (retake != null) {
      greater = retake.greater;
      less = retake.less;
    }

    var positiveOnly = mymobileConfig.allowNegativeValues.indexOf(this.json.name) == -1;

    //Set keyboard type default tel for android, web browser
    var inputType = "tel";
    if (deviceOS == "iOS") {
      inputType = "number";
    }
    if (mymobileConfig.useFullKeyboardForManualInput) {
      inputType = "";
    }

    return { id: id,
      text: this.json.text,
      decimal_places: decimal_places,
      fieldPosition: this.position,
      input_type: inputType,
      allow_neg: positiveOnly ? "false" : "true",
      designationTypes: designationTypeTemplates,
      name: this.json.name,
      greater: greater,
      less: less,
      unitName: this.unitName };
  }

});

var DesignationType = new JS.Class({

  initialize: function initialize(vital, designationTypeJson, k) {
    this.vital = vital;
    this.json = designationTypeJson;
    this.position = k;
    this.designations = [];
    var designationList = asList(this.json.designations.designation);
    for (var k = 0; k < designationList.length; k++) {
      this.designations.push(new Designation(this, designationList[k], k));
    }
  },

  template: function template() {
    var designationTemplates = [];
    _.each(this.designations, function (designation) {
      designationTemplates.push(designation.template());
    });
    return { text: this.json.label,
      id: this.vital.step.pageId() + "__dt__" + this.json.name,
      name: this.json.name,
      designations: designationTemplates };
  }

});

var Designation = new JS.Class({

  initialize: function initialize(designationType, designationJson, k) {
    this.designationType = designationType;
    this.json = designationJson;
    this.position = k;
  },

  template: function template() {
    return { text: this.json.label,
      value: this.json.name };
  }
});

var Choice = new JS.Class({

  initialize: function initialize(step, choiceJson) {
    this.step = step;
    this.json = choiceJson;
    this.position = parseInt(choiceJson.order);
  },

  choiceTemplate: function choiceTemplate() {
    var id = this.step.pageId() + "__c__" + this.position;
    return {
      id: id,
      text: this.json.text,
      choiceLabel: this.json.text,
      choiceIcon: this.json["icon-name"],
      choicePosition: this.position,
      choiceDisplayPosition: this.position + 1
    };
  },

  nextStep: function nextStep() {
    var destination = this.json['jump_to'];
    if (destination == "-1") return this.step.nextStep();else var nextStep = this.step.interview.steps[destination];

    //Move to the next step if we have a restricted sensor type.
    while (nextStep && nextStep.sensorType && Profile.hasSensorTypeRestriction(nextStep.sensorType)) {
      nextStep = this.step.interview.steps[++destination];
    }

    return this.step.jumpTo(destination);
  },

  speakContent: function speakContent() {
    if (mymobileConfig.speakInterviews) {
      Speak.interrupt(this.json.text);
    }
  }

});

var current_interview_id = null;

var Interviews = {
  interviews: null,
  completedTimes: {},

  init: function init(json) {

    // Don't update if any interviews are running!
    if (this.interviews) {
      for (var i = 0; i < this.interviews.length; i++) {
        if (this.interviews[i].isRunning()) {
          return;
        }
      }
    }

    this.interviews = [];

    this.completedTimes = {};
    this.loadCompletedTimes();

    var ilist = asList(json.interviews.interview);
    for (var i = 0; i < ilist.length; i++) {
      this.interviews.push(new Interview(ilist[i], i));
    }
  },

  orientationChange: function orientationChange(page) {

    $(".wrap-flex-choices", page).removeClass("wrap-flex-choices");
    $(".wrap-flex-choices-to-end", page).removeClass("wrap-flex-choices-to-end");
    Interviews.adjustRatingLayout(page);

    setTimeout(function () {
      Interviews.adjustRatingLayout(page);
    }, 1000);
  },

  adjustRatingLayout: function adjustRatingLayout(page) {
    // In rating steps - if the boxes get too small, turn on wrap so we don't get
    // the last row unaligned. 
    $(".wrap-flex-choices", page).removeClass("wrap-flex-choices");
    $(".wrap-flex-choices-to-end", page).removeClass("wrap-flex-choices-to-end");

    var ratingContainer = $("div.br-widget", page);
    var firstBox = ratingContainer.find("a:first");
    if (firstBox.length > 0) {

      var wrap = false;
      if (firstBox.attr('data-has-rating-icon')) {
        wrap = firstBox.width() != firstBox.height();
      } else {
        wrap = firstBox.width() < 49; //threshold for small boxes
      }

      if (wrap) {
        var flexParent = $(".flex-choices", page);

        if (flexParent.attr("data-rating-display-mode") == "endpoints_only") {
          flexParent.addClass("wrap-flex-choices-to-end");
        } else {
          flexParent.addClass("wrap-flex-choices");
        }
      }
    }
  },

  timedOut: function timedOut() {
    // save running interviews
    Interviews.stopAllBluetooth();

    if (this.interviews) {
      for (var i = 0; i < this.interviews.length; i++) {
        if (this.interviews[i].isRunning()) {
          this.interviews[i].interviewRun.timedOut();
          this.interviews[i].end();
        }
      }
    }
  },

  loadCompletedTimes: function loadCompletedTimes() {
    this.completedTimes = {};
    var self = this;
    Store.loadInterviewTimes().then(function (times) {
      if (times != null && times.length > 0 && times[0].json && times[0].json.times) {
        self.completedTimes = times[0].json.times;
        var now = new Date();
        var startDateKey = now.getFullYear() + "-" + now.getMonth() + "-" + now.getDate();
        if (!self.completedTimes[startDateKey]) {
          self.completedTimes = {};self.completedTimes[startDateKey] = {};
        }
        for (var intId in self.completedTimes[startDateKey]) {
          for (var schedId in self.completedTimes[startDateKey][intId]) {
            var intList = self.completedTimes[startDateKey][intId][schedId];
            $.each(intList, function (index, compTime) {
              compTime.timeFinished = new Date(compTime.timeFinished);
              compTime.timeStarted = new Date(compTime.timeStarted);
            });
          }
        }
      }
    });
  },

  getCompletedTimes: function getCompletedTimes(dateKey, interviewId, scheduleIdStr) {
    if (this.completedTimes[dateKey] && this.completedTimes[dateKey][interviewId] && this.completedTimes[dateKey][interviewId][scheduleIdStr]) {
      return this.completedTimes[dateKey][interviewId][scheduleIdStr];
    } else {
      return [];
    }
  },

  saveCompletedTimes: function saveCompletedTimes(interviewId, timeInfo) {
    var startDateKey = timeInfo.timeStarted.getFullYear() + "-" + timeInfo.timeStarted.getMonth() + "-" + timeInfo.timeStarted.getDate();
    if (!this.completedTimes[startDateKey]) {
      this.completedTimes = {};this.completedTimes[startDateKey] = {};
    }
    if (!this.completedTimes[startDateKey][interviewId]) {
      this.completedTimes[startDateKey][interviewId] = {};
    }
    if (!this.completedTimes[startDateKey][interviewId][timeInfo.scheduleIdStr]) {
      this.completedTimes[startDateKey][interviewId][timeInfo.scheduleIdStr] = [];
    }

    this.completedTimes[startDateKey][interviewId][timeInfo.scheduleIdStr].push(timeInfo);
    Store.saveInterviewTimes({ patientId: Auth.patientId(), times: this.completedTimes });

    Interviews.updateSchedule();
  },

  clearCompletedTimes: function clearCompletedTimes() {
    this.completedTimes = {};
    Store.saveInterviewTimes({ patientId: Auth.patientId(), times: this.completedTimes });
  },

  // called once a minute
  updateSchedule: function updateSchedule() {
    // redraw menus
    var currentPage = $.mobile.activePage.attr("id");
    if (currentPage == "interviews") this.interviewMenu();else if (currentPage == "main") this.pendingMenu();
  },

  scheduleUpdateFromTimer: function scheduleUpdateFromTimer() {
    this.updateSchedule();
  },

  scheduleMenuItem: function scheduleMenuItem(schedItem, section, page) {
    schedItem.position = schedItem.currInterview.position;
    schedItem.title = schedItem.currInterview.title;
    schedItem.startText = null;
    schedItem.expectedFinish = "";
    schedItem.section = section;
    schedItem.page = page;
    schedItem.nextLabel = null;
    if (schedItem.currSchedule) {
      schedItem.id = schedItem.currSchedule.id;
    }

    if (section == 'unscheduled') {
      schedItem.icon = 'ready';
      schedItem.asides = [];
      schedItem.hasSchedLink = true;
      schedItem.scheduleIdStr = "none";
    } else if (section == 'today') {
      schedItem.asides = [{ displayText: this.getComplexScheduleDateText(schedItem.todayDate.reminderStart, schedItem.todayDate.reminderEnd, moment().startOf('day')) }];
      if (schedItem.doneToday) {
        schedItem.asides.push({ displayText: $t("messages.interview_status.complete") });
        schedItem.icon = 'check';
        schedItem.hasSchedLink = false;
      } else if (schedItem.isLate) {
        schedItem.asides.push({ displayText: $t("messages.interview_status.missed") });
        schedItem.icon = 'missed';
        schedItem.hasSchedLink = false;
      } else if (schedItem.isNow) {
        schedItem.asides.push({ displayText: $t("messages.interview_status.ready") });
        schedItem.icon = 'ready';
        schedItem.hasSchedLink = true;
        schedItem.startText = $t("buttons.start");
        schedItem.scheduleIdStr = schedItem.todayDate.scheduleIdStr;
        schedItem.expectedFinish = schedItem.todayDate.reminderEnd;
      } else {
        schedItem.icon = 'clock';
        schedItem.hasSchedLink = false;

        if (page == 'main') {
          schedItem.nextTitle = schedItem.title;
          schedItem.nextLabel = $t("labels.next_scheduled");
          schedItem.title = null;
        }
      }
    } else if (section == 'tomorrow') {
      schedItem.icon = 'clock';
      schedItem.asides = [{ displayText: this.getComplexScheduleDateText(schedItem.tomorrowDate.reminderStart, schedItem.tomorrowDate.reminderEnd, moment().add(1, 'day').startOf('day')) }, { displayText: schedItem.currSchedule.daysText() }];
      schedItem.hasSchedLink = false;
    } else if (section == 'upcoming') {
      schedItem.icon = 'clock';

      schedItem.asides = [{ displayText: formatNextDate(schedItem.tomorrowDate.scheduleDate) }, { displayText: this.getComplexScheduleDateText(schedItem.tomorrowDate.reminderStart, schedItem.tomorrowDate.reminderEnd, schedItem.tomorrowDate.reminderStart, undefined) }];
      if (page == 'main') {
        schedItem.nextTitle = schedItem.title;
        schedItem.nextLabel = $t("labels.next_scheduled");
        schedItem.title = null;
      } else {
        schedItem.asides.push({ displayText: schedItem.currSchedule.daysText() });
      }
      schedItem.hasSchedLink = false;
    }

    if (schedItem.hasSchedLink) return ich.t_interviewMenuItemLink(schedItem, true);else return ich.t_interviewMenuItemNoLink(schedItem, true);
  },

  interviewSchedules: function interviewSchedules() {
    var startOfToday = moment().startOf('day').toDate();
    var startOfTomorrow = moment().add('days', 1).startOf('day').toDate();
    var startOfDayAfter = moment().add('days', 2).startOf('day').toDate();
    var scheds = { now: [], pending: [], today: [], tomorrow: [], upcoming: [], unscheduled: [] };

    var now = new Date();
    var dateKey = now.getFullYear() + "-" + now.getMonth() + "-" + now.getDate();

    for (var i = 0; i < this.interviews.length; i++) {
      var currentInterview = this.interviews[i];
      var interviewReady = false;
      var hasUnscheduled = false;

      console.log(currentInterview);

      if (currentInterview.schedules.length != 0) {

        for (var j = 0; j < currentInterview.schedules.length; j++) {
          var schedItem = { currInterview: currentInterview, currSchedule: currentInterview.schedules[j] };

          if (schedItem.currSchedule.time == undefined) {
            hasUnscheduled = true;
          }

          schedItem.todayDate = schedItem.currSchedule.computeNextDate(now);

          if (schedItem.todayDate != undefined) {
            var startTime = schedItem.todayDate.reminderStart.getTime();
            if (startTime < startOfTomorrow.getTime()) {
              scheds.today.push(schedItem);

              schedItem.isNow = now >= schedItem.todayDate.reminderStart && now <= schedItem.todayDate.reminderEnd;
              schedItem.isLate = now > schedItem.todayDate.reminderEnd;

              var completedTimes = this.getCompletedTimes(dateKey, currentInterview.id, schedItem.currSchedule.getScheduleIDStr());
              var registeredAsComplete = false;
              var lastRegistered = schedItem.currSchedule.last_completed;
              if (lastRegistered && moment(lastRegistered).isBetween(schedItem.todayDate.reminderStart, schedItem.todayDate.reminderEnd)) {
                registeredAsComplete = true;
              }
              schedItem.doneToday = completedTimes.length > 0 || registeredAsComplete;

              if (schedItem.isNow && !schedItem.doneToday) {
                interviewReady = true;
              }

              if (!schedItem.doneToday && schedItem.isNow) {
                scheds.now.push(schedItem);
              }
              if (!schedItem.doneToday && !schedItem.isNow && !schedItem.isLate) {
                scheds.pending.push(schedItem);
              }
            }
          }

          schedItem.tomorrowDate = schedItem.currSchedule.computeNextDate(startOfTomorrow);
          if (schedItem.tomorrowDate != undefined) {
            var tomorrowStartTime = schedItem.tomorrowDate.reminderStart.getTime();
            var todayReminderStartTime = schedItem.todayDate.reminderStart.getTime();
            var tomorrowReminderStartTime = schedItem.tomorrowDate.reminderStart.getTime();
            var is_tomorrow = schedItem.todayDate == undefined || todayReminderStartTime != tomorrowReminderStartTime;

            if (todayReminderStartTime == tomorrowReminderStartTime) {
              // overlaping schedules
              tomorrowReminderStartTime = schedItem.currSchedule.computeNextDate(schedItem.tomorrowDate.reminderEnd);
              is_tomorrow = todayReminderStartTime != tomorrowReminderStartTime;
            }

            if (is_tomorrow && tomorrowStartTime < startOfDayAfter.getTime()) {
              scheds.tomorrow.push(schedItem);
            } else {
              scheds.upcoming.push(schedItem);
            }
          }
        }
      }

      if (!interviewReady && (!mymobileConfig.filter_unscheduled_interviews || hasUnscheduled)) {
        scheds.unscheduled.push({ currInterview: currentInterview, currSchedule: null });
      }
    }
    var schedTomorrowSortFunc = function schedTomorrowSortFunc(a, b) {
      var aDate = a.tomorrowDate;
      if (!aDate) {
        aDate = a.todayDate;
      }
      var bDate = b.tomorrowDate;
      if (!bDate) {
        bDate = b.todayDate;
      }

      return schedSortFunc(a, b, aDate, bDate);
    };

    var schedTodaySortFunc = function schedTodaySortFunc(a, b) {
      return schedSortFunc(a, b, a.todayDate, b.todayDate);
    };

    var schedSortFunc = function schedSortFunc(a, b, aDate, bDate) {
      if (aDate && bDate) {
        var startDiff = aDate.reminderStart - bDate.reminderStart;
        if (startDiff != 0) {
          return startDiff;
        }
        var endDiff = aDate.reminderEnd - bDate.reminderEnd;
        if (endDiff != 0) {
          return endDiff;
        }
      }
      return a.currInterview.title.localeCompare(b.currInterview.title);
    };

    scheds.unscheduled = scheds.unscheduled.sort(function (a, b) {
      return a.currInterview.title.toLowerCase().trim().localeCompare(b.currInterview.title.toLowerCase().trim());
    });
    scheds.today = scheds.today.sort(schedTodaySortFunc);
    scheds.tomorrow = scheds.tomorrow.sort(schedTomorrowSortFunc);
    scheds.upcoming = scheds.upcoming.sort(schedTomorrowSortFunc);
    scheds.now = scheds.now.sort(schedTodaySortFunc);
    scheds.pending = scheds.pending.sort(schedTomorrowSortFunc);

    scheds.current = null;
    if (scheds.now.length > 0) {
      scheds.current = { schedItem: scheds.now[0], section: "today" };
    } else if (scheds.pending.length > 0) {
      scheds.current = { schedItem: scheds.pending[0], section: "today" };
    } else if (scheds.tomorrow.length > 0) {
      scheds.current = { schedItem: scheds.tomorrow[0], section: "upcoming" };
    } else if (scheds.upcoming.length > 0) {
      scheds.current = { schedItem: scheds.upcoming[0], section: "upcoming" };
    }

    return scheds;
  },

  interviewMenu: function interviewMenu() {
    var scheds = this.interviewSchedules();
    var str = '';
    var unschedStr = '';
    var unschedAllStr = '';
    var unschedSensorStr = '';
    var unschedNoSensorStr = '';

    if (scheds.unscheduled.length > 0) {
      unschedStr += '<li data-role="list-divider" class="interview-unscheduled-header" >' + $t("menus.unscheduled_interviews") + '</li>';
      $.each(scheds.unscheduled, function (index, sched) {
        var intString = Interviews.scheduleMenuItem(sched, 'unscheduled', "plan");
        unschedAllStr += intString;

        if (sched.currInterview.hasSensorStep()) {
          unschedSensorStr += intString;
        } else {
          unschedNoSensorStr += intString;
        }
      });
    }

    if (mymobileConfig.show_sensor_interviews_first) {
      unschedStr += unschedSensorStr + unschedNoSensorStr;
    } else {
      unschedStr += unschedAllStr;
    }

    if (mymobileConfig.show_unscheduled_interviews_first) {
      str += unschedStr;
    }

    str += '<li data-role="list-divider" class="interview-today-header">' + $t("menus.todays_schedule") + '</li>';
    if (scheds.today.length == 0) str += '<li>' + $t("menus.no_scheduled_interviews") + '</li>';else {
      $.each(scheds.today, function (index, sched) {
        str += Interviews.scheduleMenuItem(sched, 'today', "plan");
      });
    }

    str += '<li data-role="list-divider" class="interview-tomorrow-header" >' + $t("menus.tomorrows_schedule") + '</li>';
    if (scheds.tomorrow.length == 0) str += '<li>' + $t("messages.no_scheduled_interviews") + '</li>';else {
      $.each(scheds.tomorrow, function (index, sched) {
        str += Interviews.scheduleMenuItem(sched, 'tomorrow', "plan");
      });
    }
    if (scheds.upcoming.length > 0) {
      str += '<li data-role="list-divider" class="interview-upcoming-header">' + $t("menus.upcoming_schedule") + '</li>';
      $.each(scheds.upcoming, function (index, sched) {
        str += Interviews.scheduleMenuItem(sched, 'upcoming', "plan");
      });
    }

    if (!mymobileConfig.show_unscheduled_interviews_first) {
      str += unschedStr;
    }

    $('#interviews-menu').html($(str)).listview("refresh");
    addLongTap($('#interviews-menu')[0]);
    orientationUpdate();
  },

  pendingMenu: function pendingMenu() {

    var scheds = this.interviewSchedules();

    $('#main-menu li:first-child').remove();

    if (scheds.current != null) $('#main-menu').prepend(Interviews.scheduleMenuItem(scheds.current.schedItem, scheds.current.section, "main"));else $('#main-menu').prepend($("<li>" + $t("menus.no_interviews_pending") + "</li>"));

    $('#main-menu').listview("refresh");
    addLongTap($('#main-menu li:first')[0]);
    orientationUpdate();
  },

  findById: function findById(id) {
    for (var i = 0; this.interviews != null && i < this.interviews.length; i++) {
      if (id == this.interviews[i].id) return this.interviews[i];
    }
    return null;
  },

  findStepById: function findStepById(id) {
    if (this.interviews) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.interviews[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var interview = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = interview.steps[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var step = _step3.value;

              if (step.json.id == id) {
                return step;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    return null;
  },

  pendingInterview: function pendingInterview(overElement) {
    openMessagePopup($t("messages.interview_is_pending"), overElement);
  },

  runInterview: function runInterview(interviewIndex, scheduleIdStr, expectedFinish, schedId) {
    var run = new InterviewRun(this.interviews[interviewIndex], Auth.patientId(), scheduleIdStr, expectedFinish, schedId);
    current_interview_id = interviewIndex;
    run.start();
  },

  choiceClicked: function choiceClicked(elem, interviewPos, stepPos, isRating) {
    var parentDiv = $(elem).closest(".ui-content");

    var choicePos = $(elem).data('choice');
    if (isRating && choicePos === undefined) {
      choicePos = $(elem).closest(".rating-control").attr('data-choice-position');
    }

    if (choicePos !== undefined) {
      choicePos = parseInt(choicePos);
      var choice = this.interviews[interviewPos].steps[stepPos].choices[choicePos];
      if (choice && mymobileConfig.speakInterviews) {
        choice.speakContent();
      }
    }

    if (mymobileConfig.confirmAnswers) {
      $(".question-next", parentDiv).show();
      return false;
    } else {
      if (isRating) this.ratingNextClicked(elem, interviewPos, stepPos);else this.choiceNextClicked(elem, interviewPos, stepPos);
      return true;
    }
  },

  advanceSlider: function advanceSlider(elem, increment) {
    var control = $(elem).closest(".rating-control");
    var slider = control.find('input.slider');
    var val = parseInt(slider.val());
    slider.val(val + increment);
    slider.slider("refresh");
  },

  choiceNextClicked: function choiceNextClicked(elem, interviewPos, stepPos) {
    var parentDiv = $(elem).closest(".ui-content");
    var sel = $("input:checked", parentDiv);
    var choicePos = sel.attr('data-choice');

    this.interviews[interviewPos].choiceNextClicked(stepPos, choicePos);
  },

  ratingNextClicked: function ratingNextClicked(elem, interviewPos, stepPos) {
    var parentDiv = $(elem).closest(".ui-content");
    var sel = $(".rating-control", parentDiv);
    var choicePos = sel.attr('data-choice-position');

    if (!choicePos) {
      sel = $("input:checked", parentDiv);
      choicePos = sel.attr('data-choice');
    }

    this.interviews[interviewPos].choiceNextClicked(stepPos, choicePos);
  },

  linkClicked: function linkClicked(interviewPos, stepPos, linkId) {
    var step = this.interviews[interviewPos].steps[stepPos];
    linkId = parseInt(linkId);
    var link = step.links.find(function (lnk) {
      return lnk.id === linkId;
    });
    if (link) {
      window.open(link.makeUrl(), "_system");
    }
  },

  nextClicked: function nextClicked(interviewPos, stepPos) {
    this.interviews[interviewPos].nextClicked(stepPos);
  },

  openDialog: function openDialog(dialogId) {

    $(dialogId).popup('open', { history: false });
  },

  toggleInputMode: function toggleInputMode(elem, mode) {
    var parentDiv = $(elem).closest('.ui-content');

    Interviews.resetFeedback(parentDiv);

    //Reset inputs
    $('input', parentDiv).val("");
    $('.interview-inputs', parentDiv).removeData('additionalReadings');

    if (mymobileConfig.speakInterviews) {
      Speak.stop();
    }

    if (mode == 'auto') {
      $(".sensor-next", parentDiv).hide();
      var sensor = $('.automatic-sensor-control', parentDiv).data('sensor');
      Interviews.setSensor(parentDiv, sensor);
      Interviews.startSensorReadings($('.automatic-sensor-control', parentDiv));
      Interviews.showSensorInputs(parentDiv, sensor.device.allowManual());
    } else {

      if (mymobileConfig.speakInterviews) {
        Speak.interrupt($t("interviews.manual_warning"));
      }

      Interviews.stopAllBluetooth();
      Interviews.showManualInputs(parentDiv);
      Interviews.unsetSensor(parentDiv);
      Interviews.hideProgress(parentDiv);
    }
  },

  showManualInputs: function showManualInputs(html) {
    if (html == null) {
      html = $("div.ui-content");
    }

    $('.sensor-next', html).show();
    $('.sensor-accept', html).hide();
    $('.sensor-skip', html).hide();
    $('div.automatic-sensor-control', html).hide();
    $('ul.interview-inputs li.interview-input-field', html).show();

    $('.input-switch-button-automatic', html).show();
    $('.input-switch-button-manual', html).hide();
    $('.input-switch-manual-warning', html).show();
  },

  showSensorInputs: function showSensorInputs(html, allowManual) {
    if (html == null) {
      html = $("div.ui-content");
    }

    $('.input-mode-switch-container', html).show();
    $('.sensor-manual-retake', html).hide();
    $('ul.interview-inputs li.interview-input-field', html).hide();
    $('.sensor-accept', html).hide();
    $('.sensor-next', html).hide();
    $('.sensor-skip', html).show();
    $('div.automatic-sensor-control', html).show();
    $('.sensor-button', html).show();

    $('.input-switch-button-automatic', html).hide();

    if (allowManual) {
      $('.input-switch-button-manual', html).show();
    } else {
      $('.input-switch-button-manual', html).hide();
    }

    $('.input-switch-manual-warning', html).hide();
  },

  setSensor: function setSensor(html, sensor) {
    if (html == null) {
      html = $("div.ui-content");
    }

    $('.automatic-sensor-control', html).data('sensor', sensor);

    var sensorControl = $('div.automatic-sensor-control', html);
    $(sensorControl).attr("data-sensor-identification", sensor.identification);

    //Add Triage Manager sensor id to form inputs
    $('.interview-inputs', html).attr('data-sensor-id', sensor.id);
  },

  unsetSensor: function unsetSensor(html) {
    if (html == null) {
      html = $("div.ui-content");
    }

    //Remove Triage Manager sensor id from form inputs
    $('.interview-inputs', html).removeAttr('data-sensor-id');
  },

  stopAllBluetooth: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.stopWaitingForBluetooth();
              _context.next = 3;
              return BLE_CONTROL.stopAllReadings();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function stopAllBluetooth() {
      return _ref.apply(this, arguments);
    }

    return stopAllBluetooth;
  }(),

  stopWaitingForBluetooth: function stopWaitingForBluetooth() {
    if (this.waitForBTInterval) {
      clearInterval(this.waitForBTInterval);
      this.waitForBTInterval = null;
    }
  },

  startWaitingForBluetooth: function startWaitingForBluetooth(elem) {
    var _this2 = this;

    if (this.waitForBTInterval == null) {
      this.waitForBTInterval = setInterval(function () {
        BLE_CONTROL.checkIfEnabledPromise().then(function (enabled) {
          if (enabled && _this2.waitForBTInterval != null) {
            _this2.stopWaitingForBluetooth();
            _this2.startSensorReadings(elem);
          }
        });
      }, 1000);
    }
  },

  startSensorReadings: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(elem) {
      var sensor, btEnabled;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log("startSensorReadings");
              sensor = $(elem).data('sensor');
              _context2.next = 4;
              return this.stopAllBluetooth();

            case 4:
              console.log("startSensorReadings");

              if (!this.checkSensor(sensor)) {
                _context2.next = 12;
                break;
              }

              _context2.next = 8;
              return BLE_CONTROL.enablePromise();

            case 8:
              btEnabled = _context2.sent;

              if (!btEnabled) {
                this.sensorError(elem, $t("sensors.bluetooth_disabled"));

                if (mymobileConfig.speakInterviews) {
                  Speak.continue($t("sensors.bluetooth_disabled"));
                }

                this.startWaitingForBluetooth(elem);
              } else {
                this.getSensorReadings(elem);
              }
              _context2.next = 13;
              break;

            case 12:
              this.sensorError(elem, $t("interviews.sensor_status.not_supported"));

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function startSensorReadings(_x) {
      return _ref2.apply(this, arguments);
    }

    return startSensorReadings;
  }(),

  checkSensor: function checkSensor(sensor) {
    if (inBrowser) {
      console.error("Cannot Scan. App running in Browser.");
      return false;
    }

    if (!sensor) {
      console.error("No sensor set in sensor control div.");
      return false;
    }

    if (!sensor.device) {
      console.error("Sensor unsupported by mymobile.");
      return false;
    }

    if (!sensor.device.isSupported()) {
      console.error("Sensor unsupported by OS.");
      return false;
    }

    return true;
  },

  sensorError: function sensorError(elem, errMess) {
    var parentDiv = $(elem).closest('.ui-content');

    Interviews.updateSensorStatus(errMess, elem);
    $('.sensor-manual-retake', parentDiv).hide();
    Interviews.hideProgress(parentDiv);
  },

  getSensorReadings: function getSensorReadings(elem) {

    var parentDiv = $(elem).closest('.ui-content');
    var stepDiv = $(elem).closest('.interview-step');

    var stepId = $(stepDiv).data("step-id");
    var step = Interviews.findStepById(stepId);

    var sensor = $(elem).data('sensor');

    Interviews.updateSensorStatus($t("interviews.sensor_status.scanning"), elem);
    Interviews.showProgress(parentDiv);

    inputsContainer = $(elem).parents(".ui-content").find(".interview-inputs");

    var progressFunc = function progressFunc(notification) {
      Interviews.updateSensorStatus(notification, elem);
    };

    sensor.device.waitForReadings({}, progressFunc).then(function (result) {
      console.log("Response from Sensor: ", result);

      var initial_reading_count = result.readings.length;

      Interviews.updateSensorMessage(null, elem);

      result.readings = result.readings.filter(function (reading) {
        return !reading.duplicate && !reading.measurements.length <= 0;
      });

      console.log(initial_reading_count - result.readings.length + ' reading(s) thrown away.');

      if (result.readings.length > 0) {
        Interviews.updateSensorStatus($t("interviews.sensor_status.vitals_collected"), elem);
        Interviews.hideProgress(elem);

        if (sensor.device.collectsBinaryData) {
          console.log("Saving binary data result to DOM");
          inputsContainer.data("sensor-reading", result);
        } else {
          Interviews.fillFieldsFromSensor(step, result.readings, inputsContainer, sensor, result.batteryStatus);
        }

        var oldestReadingDate;
        for (var index in result.readings) {
          result.readings[index].date = new Date(result.readings[index].date);
          if (!oldestReadingDate || oldestReadingDate.getTime() > result.readings[index].date.getTime()) {
            oldestReadingDate = result.readings[index].date;
          }
        }

        BLE_CONTROL.clearOlderTempReadings(sensor.identification, oldestReadingDate);

        Interviews.showSensorReadingsforVerification(inputsContainer);
        Interviews.stopAllBluetooth();
      } else {

        if (initial_reading_count > 0) {
          // tell the patient all readings were duplicates
          Interviews.updateSensorMessage($t("interviews.sensor_status.no_new_readings"), elem);
        }
        Interviews.resetSensorStep(parentDiv, null, true);
      }
    }, function (error) {
      //Interviews.updateSensorStatus($t("interviews.sensor_status.could_not_connect"), elem);
      console.log("BT error - ");
      console.error(error);
      if (error.stopped) {
        console.log("Do not restart scan");
      } else {
        console.log("restarting scan");
        setTimeout(function () {
          Interviews.startSensorReadings(elem);
        }, 1000);
      }
    });
  },

  stopSensorReadings: function stopSensorReadings(elem) {
    if (inBrowser) {
      console.error("App running in Browser.");
      return false;
    }

    var sensor = $(elem).data('sensor');

    sensor.device.disconnect(function (result) {
      Interviews.updateSensorStatus(null, elem);
    });
  },

  fillFieldsFromSensor: function fillFieldsFromSensor(step, readings, inputsContainer, sensor, batteryStatus) {
    var additionalReadings = [];
    var spokenReadings = [];
    $.each(readings, function (r_index, reading) {
      if (reading.main == true || r_index == 0) {
        reading.batteryStatus = batteryStatus;
        $(inputsContainer).data('sensor-reading', reading);

        $.each(reading.measurements, function (m_index, measurement) {

          console.log(measurement.name, " : " + measurement.value, measurement.unit, measurement.designation);
          elem = $("input[name=" + measurement.name + "]", inputsContainer);
          if (elem.length == 1) {
            if (measurement.unit == "lb") {
              measurement.unit = "lbs";
            }
            elem.attr("data-sensor-unit", measurement.unit);
            elem.attr("data-sensor-value", measurement.value);
            elem.attr("data-sensor-designations", measurement.designations.join());
            elem.attr("data-sensor-checksum", reading.checksum);

            var toUnit = elem.attr("data-measurement-unit");
            var decimalPlaces = parseInt(elem.attr("data-measurement-decimal-places"));
            var val = Profile.convertMeasurementUnits(measurement.value, measurement.unit.toLowerCase(), toUnit, measurement.name, sensor['sensor-model-name'], decimalPlaces);
            var displayVal = val.replace(".", $t("numbers.decimal_separator"));

            var fieldPosition = parseInt(elem.attr("vitals-position"));

            spokenReadings.push({ measurement: measurement, displayVal: displayVal, fieldPosition: fieldPosition });

            elem.val(displayVal);
            elem.trigger('blur');
          } else {
            console.error("Could not find input tag to read sensor data into.", measurement);
          }
        });
      } else {
        console.log("Stored Addit reading: ", reading);
        additionalReadings.push(reading);
        Interviews.addAdditionalReadingToStep(reading, inputsContainer);
      }
    });

    var speakBP = {};
    spokenReadings = spokenReadings.sort(function (a, b) {
      return a.fieldPosition - b.fieldPosition;
    });
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = spokenReadings[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var sReading = _step4.value;

        step.speakReading(sReading.measurement, sReading.displayVal, speakBP);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    console.log("Additional Readings: ", additionalReadings);
    var parentDiv = $(inputsContainer).closest('.ui-content');
    if (additionalReadings.length > 0) {
      var messages = [$t("interviews.sensor_status.verify_readings"), $t("interviews.additional_reading_saved").replace("{{count}}", "" + additionalReadings.length)];
      var messageInfo = { message: messages.join("<br>"),
        speakText: messages.join(" ") };
      Interviews.updateSensorStatus(messageInfo, parentDiv);
    }
  },

  addAdditionalReadingToStep: function addAdditionalReadingToStep(reading, inputsContainer) {
    console.log("Add additional reading: ", reading);

    if (reading.measurements) {
      for (var j = 0; j < reading.measurements.length; j++) {
        if (reading.measurements[j].designations) {
          reading.measurements[j].designations = reading.measurements[j].designations.filter(function (val) {
            return val !== null;
          });
        }
      }
    }

    var additionalReadings;
    if ($(inputsContainer).data('additionalReadings') == undefined) {
      additionalReadings = [reading];
    } else {
      additionalReadings = $(inputsContainer).data('additionalReadings');
      additionalReadings.push(reading);
    }

    $(inputsContainer).data('additionalReadings', additionalReadings);
  },
  showSensorReadingsforVerification: function showSensorReadingsforVerification(elem) {
    parentDiv = $(elem).parent();

    Interviews.updateSensorStatus(null, elem);

    //If we have binary data, don't show confirmation.    
    var sensor = Profile.getSensorByTMId(elem.data('sensorId'));
    if (sensor && sensor.device.collectsBinaryData) {
      $(".sensor-accept a", parentDiv).click();
    }

    Interviews.disableInputs(elem);

    $('div.automatic-sensor-control .sensor-button', parentDiv).hide();
    $('.sensor-manual-retake', parentDiv).show();

    $('ul.interview-inputs li.interview-input-field', parentDiv).show();
    $('.input-mode-switch-container', parentDiv).hide();
    $(".designation-input-field", parentDiv).hide();

    $(".sensor-accept", parentDiv).show();
    $('.sensor-skip', parentDiv).hide();
  },

  updateSensorMessage: function updateSensorMessage(message, elem) {
    var message_elem = $(".sensor-message", elem);
    if (message == null) {
      $(message_elem).hide();
      $(message_elem).html("");
    } else {
      $(message_elem).show();
      $(message_elem).html(message);
    }
  },

  showProgress: function showProgress(elem) {
    var parentDiv = $(elem).closest('.interview-step');
    var connect_progress_elem = $(".sensor-connect-progress", parentDiv);
    connect_progress_elem.show();
  },

  hideProgress: function hideProgress(elem) {
    var parentDiv = $(elem).closest('.interview-step');
    var connect_progress_elem = $(".sensor-connect-progress", parentDiv);
    connect_progress_elem.hide();
  },

  updateSensorStatus: function updateSensorStatus(status, elem) {
    var status_elem = $(".sensor-status", elem);

    $(status_elem).hide();

    if ($.type(status) === 'string') {
      status = { message: status };
    }

    if (status && status.message) {
      $(status_elem).show();

      if (!status.settingsOnly) {
        $(status_elem).html(status.message);

        if (mymobileConfig.speakInterviews) {
          var speakText = status.speakText;
          if (!speakText) {
            speakText = status.message;
          }
          //Speak.continueIfChanged( speakText )
        }
      }
    }
  },

  enableInputs: function enableInputs(elem) {
    $('input', elem).prop('disabled', false);
  },

  disableInputs: function disableInputs(elem) {
    $('input', elem).prop('disabled', true);
  },

  openCurrentRetake: function openCurrentRetake(elem) {
    var interviewPos = $(elem).attr("data-interview");
    var stepPos = $(elem).attr("data-step");
    this.interviews[interviewPos].retakeClicked(stepPos);
  },

  interviewQuitClicked: function interviewQuitClicked(elem, pageId) {

    if (inBrowser) {
      Interviews.openDialog('#popupBasic-' + pageId);
    } else {
      var pageDiv = $("#" + pageId);
      var interviewPosition = pageDiv.data("interview-index");

      navigator.notification.confirm($t("interviews.exit_interview_question_warning"), function (result) {
        Speak.stop();
        if (result == 2) {
          Interviews.interviews[interviewPosition].goToPage('#q_exit_no_save');
        }
      }, $t("interviews.exit_interview_question_confirm"), [$t('buttons.resume'), $t('buttons.quit')]);
    }
    if (mymobileConfig.speakInterviews) {
      Speak.interrupt($t("interviews.exit_interview_question_confirm"));
      Speak.continue($t("interviews.exit_interview_question_warning"));
    }
  },

  interviewVolumeClicked: function interviewVolumeClicked(elem, pageId) {

    var volOff = $(elem).hasClass("ui-icon-volume-off-large");

    if (volOff) {
      $(".ui-icon-volume-off-large").addClass("ui-icon-volume-up-large").removeClass("ui-icon-volume-off-large");
      Speak.setVolume("up");
    } else {
      $(".ui-icon-volume-up-large").addClass("ui-icon-volume-off-large").removeClass("ui-icon-volume-up-large");
      Speak.setVolume("off");
    }
  },

  vitalsSkipClicked: function vitalsSkipClicked(elem, pageId) {
    Interviews.stopAllBluetooth();
    console.log("Vitals skip clicked");

    if (inBrowser) {
      Interviews.openDialog('#popupSkipConfirm-' + pageId);
    } else {
      var pageDiv = $("#" + pageId);
      var interviewPosition = pageDiv.data("interview-index");
      var stepPosition = pageDiv.data("step-index");

      navigator.notification.confirm($t("interviews.are_you_sure_you_want_to_skip"), function (result) {
        if (result == 1) {
          Interviews.vitalsCancelSkipClicked(elem, interviewPosition, stepPosition);
        } else {
          Interviews.vitalsConfirmSkipClicked(elem, interviewPosition, stepPosition);
        }
      }, $t("interviews.skip_reading"), [$t('buttons.cancel'), $t('interviews.skip')]);
    }

    Interviews.hideProgress(elem);

    if (mymobileConfig.speakInterviews) {
      Speak.interrupt($t("interviews.are_you_sure_you_want_to_skip"));
    }
  },

  vitalsNextClicked: function vitalsNextClicked(elem) {
    this.showManualInputs();

    var parentDiv = $(elem).closest(".ui-content");
    var emptyFields = [];
    var numFields = $(".vitals-input", parentDiv).length;
    $(".vitals-input-error", parentDiv).text("").hide();
    $(".vitals-input", parentDiv).blur();

    $(".vitals-input", parentDiv).each(function () {
      var val = $.trim($(this).val());
      if (val == "") {
        $(".vitals-input-error", $(this).closest("li")).text($t("interviews.reading_blank")).show();
        emptyFields.push(this);
      }
    });

    var message;
    if (false == this.hasSBPandDBP($(".vitals-input", parentDiv))) {
      message = $t("interviews.sbp_dbp_missing");
      $(".bottom-message-box-text", parentDiv).text(message);
      $(".bottom-message-box", parentDiv).show();
    } else {

      message = $t("interviews.verify_readings");
      if (emptyFields.length > 0) {
        if (numFields == 1) {
          message = $t("interviews.one_blank_reading");
        } else if (numFields == emptyFields.length) {
          message = $t("interviews.all_blank_readings");
        } else {
          message = $t("interviews.some_blank_readings");
        }
      }

      $(".sensor-confirm", parentDiv).show();
      $(".sensor-confirm-text", parentDiv).text(message);
    }

    if (mymobileConfig.speakInterviews) {
      Speak.interrupt(message);
    }

    $(".sensor-next", parentDiv).hide();

    return false;
  },

  manualRetakeClicked: function manualRetakeClicked(elem, interviewPos, stepPos) {
    Interviews.saveCurrentVitals(elem, interviewPos, stepPos);
    this.resetSensorStep(parentDiv, null, false);
  },

  goBackOneStep: function goBackOneStep(interviewPos) {
    this.interviews[interviewPos].goBackOneStep();
  },

  resetFeedback: function resetFeedback(parentDiv, vitalsDiv) {
    $(".sensor-confirm", parentDiv).hide();
    $(".bottom-message-box", parentDiv).hide();
    $(".sensor-next", parentDiv).show();
    if (vitalsDiv == null) {
      vitalsDiv = parentDiv;
    }
    $(".vitals-input-error", vitalsDiv).text("").hide();
    $(".interview-inputs", parentDiv).show();
  },

  resetSensorStep: function resetSensorStep(parentDiv, vitalsDiv, isRetry) {

    $('.interview-inputs', parentDiv).removeData('sensor-reading');

    $('.interview-inputs', parentDiv).removeData('additionalReadings');
    $('.interview-inputs', parentDiv).removeData('sensorDesignations');

    $('.interview-inputs input', parentDiv).removeAttr("data-sensor-unit data-sensor-value data-sensor-designations data-sensor-checksum");

    $(".sensor-confirm", parentDiv).hide();
    $(".bottom-message-box", parentDiv).hide();
    $(".sensor-next", parentDiv).show();
    if (vitalsDiv == null) {
      vitalsDiv = parentDiv;
    }
    $(".vitals-input-error", vitalsDiv).text("").hide();
    $(".interview-inputs", parentDiv).show();
    $(".automatic-sensor-control", parentDiv).hide();
    $(".automatic-sensor-control .sensor-status", parentDiv).hide();
    if (!isRetry) {
      $(".automatic-sensor-control .sensor-message", parentDiv).hide();
      this.hideProgress(parentDiv);
    }
    $(".input-mode-switch-container-container", parentDiv).hide();
    $(".sensor-manual-retake", parentDiv).hide();
    $(".sensor-accept", parentDiv).hide();

    Interviews.updateSensorStatus(null, parentDiv);

    this.enableInputs(parentDiv);
    this.showManualInputs(parentDiv);
    this.unsetSensor(parentDiv);

    if ($('.automatic-sensor-control', parentDiv).data('sensor')) {
      var sensor = $('.automatic-sensor-control', parentDiv).data('sensor');
      this.setSensor(parentDiv, sensor);
      Interviews.startSensorReadings($('.automatic-sensor-control', parentDiv));
      this.showSensorInputs(parentDiv, sensor.device.allowManual());
    }
  },

  saveVitalsDeferred: function saveVitalsDeferred(elem, sensorId, inRetake, interviewPos, stepPos, deferredArray) {
    var deferred = $.Deferred();
    Interviews.saveVitals(elem, sensorId, inRetake, interviewPos, stepPos, deferredArray);
    return $.when.apply($, deferredArray);
  },

  saveVitals: function saveVitals(elem, sensorId, inRetake, interviewPos, stepPos, deferredArray) {
    var checksum;
    var date = new Date();
    var vitals = [];
    var batteryStatus = null;

    var sensorReading = $('.interview-inputs', elem).data('sensor-reading');
    if (sensorReading && sensorReading.checksum) {
      checksum = sensorReading.checksum;
    }
    if (sensorReading && sensorReading.date) {
      date = sensorReading.date;
    }
    if (sensorReading && sensorReading.batteryStatus) {
      batteryStatus = sensorReading.batteryStatus;
    }

    var sensor = Profile.getSensorByTMId(sensorId);
    if (sensorReading && sensor && sensor.device.collectsBinaryData) {
      vitals.push({ vitalPos: 0,
        vitalVal: null,
        designations: [],
        sensorValue: sensorReading.readings[0].measurements[0].value,
        sensorUnit: null });
    }

    $(".vitals-input", elem).each(function (index, inputElem) {
      var input = this;
      var designations = [];
      var parentDiv = $(this).closest('.ui-content');
      $(".designation-input[vitals-position=" + $(input).attr('vitals-position') + "]", parentDiv).each(function () {
        var val = $(this).val();
        if (val != "0") {
          designations.push({ name: $(this).val(), type: $(this).attr('designation-type') });
        }
      });

      if ($(this).attr('data-sensor-designations')) {
        designations = $(this).attr('data-sensor-designations');
      }
      vitals.push({ vitalPos: parseInt($(this).attr('vitals-position')),
        vitalVal: $(this).val(),
        designations: designations,
        sensorValue: $(this).attr('data-sensor-value'),
        sensorUnit: $(this).attr('data-sensor-unit') });
    });

    if (deferredArray) {
      var deferred = $.Deferred();
      deferredArray.push(deferred);
    }
    this.interviews[interviewPos].saveVitals(stepPos, vitals, inRetake, sensorId, date, batteryStatus, checksum, deferred);

    var inputsContainer = $('.interview-inputs', elem);
    var additionalVitals = [];

    if (inputsContainer && inputsContainer.data('additionalReadings')) {
      var additionalReadings = inputsContainer.data('additionalReadings');
      console.log("Saving " + additionalReadings.length + " additional reading(s).");

      var interviews = this.interviews;
      $.each(additionalReadings, function (index, reading) {
        console.log("Additional Reading: ", reading);
        if (reading.checksum) {
          checksum = reading.checksum;
        }

        date = reading.date;
        for (var i = 0; i < reading.measurements.length; i++) {
          var measurement = reading.measurements[i];
          var designations = measurement.designations.join();
          additionalVitals.push({
            name: measurement.name,
            designations: designations,
            sensorValue: measurement.value,
            sensorUnit: measurement.unit
          });
        }
        if (deferredArray) {
          var deferred = $.Deferred();
          deferredArray.push(deferred);
        }
        interviews[interviewPos].saveVitals(stepPos, additionalVitals, inRetake, sensorId, date, batteryStatus, checksum, deferred);
      });
    }
  },

  focusVital: function focusVital(elem) {
    var parentDiv = $(elem).closest(".ui-content");
    var vitalsDiv = $(elem).closest("li");
    this.resetFeedback(parentDiv, vitalsDiv);
  },

  vitalsConfirmSkipClicked: function vitalsConfirmSkipClicked(elem, interviewPos, stepPos) {
    console.log("Confirm skip vitals.");

    if (mymobileConfig.speakInterviews) {
      Speak.stop();
    }

    Interviews.saveCurrentVitals(elem, interviewPos, stepPos);
    this.interviews[interviewPos].vitalsNextClicked(stepPos);
  },

  saveCurrentVitals: function saveCurrentVitals(elem, interviewPos, stepPos) {
    var parentDiv = $(elem).closest(".ui-content");
    var sensorId = $(parentDiv).find('.interview-inputs').data('sensor-id');
    var inRetake = this.interviews[interviewPos].repeated[stepPos];
    Interviews.saveVitals($(parentDiv), sensorId, inRetake, interviewPos, stepPos);
  },

  vitalsCancelSkipClicked: function vitalsCancelSkipClicked(elem, interviewPos, stepPos) {
    console.log("Cancel skip vitals. ", interviewPos, "-", stepPos);

    if (mymobileConfig.speakInterviews) {
      Speak.stop();
    }

    var parentDiv = $(elem).closest(".ui-content");
    Interviews.startSensorReadings($('.automatic-sensor-control', parentDiv));
  },

  vitalsConfirmNextClicked: function vitalsConfirmNextClicked(elem, interviewPos, stepPos) {
    var parentDiv = $(elem).closest(".ui-content");
    var sensorId = $(parentDiv).find('.interview-inputs').data('sensor-id');
    var inRetake = this.interviews[interviewPos].repeated[stepPos];

    // save vitals
    var deferredArray = [];
    Interviews.saveVitalsDeferred($(parentDiv), sensorId, inRetake, interviewPos, stepPos, deferredArray).done(function () {
      if (!inRetake && Interviews.retakeLimitExceeded(parentDiv)) {
        Interviews.interviews[interviewPos].repeated[stepPos] = true;
        Interviews.resetSensorStep(parentDiv, null, false);
        $(".vitals-input", parentDiv).each(function () {
          $(this).val("");
        });
        $("#retake_continue").attr("data-interview", interviewPos).attr("data-step", stepPos);

        if (mymobileConfig.speakInterviews) {
          Speak.interrupt($t("messages.redo_sync"));
        }

        $(":mobile-pagecontainer").pagecontainer("change", '#dialog-message-redo', { changeHash: false, transition: 'pop', role: 'dialog' });
      } else {

        var promptMsgList = Profile.checkPromptLimits(parentDiv);

        if (promptMsgList.length > 0) {
          $("#current-prompt-message").html(promptMsgList.join("<br/><br/>"));
          $("#prompt_continue").attr("data-interview", interviewPos).attr("data-step", stepPos);

          $(":mobile-pagecontainer").pagecontainer("change", '#dialog-message-prompt', { changeHash: false, transition: 'pop', role: 'dialog' });
        } else {
          Interviews.interviews[interviewPos].vitalsNextClicked(stepPos);
        }
      }
    });
  },

  continueFromPrompt: function continueFromPrompt(elem) {
    var interviewPos = $(elem).attr("data-interview");
    var stepPos = $(elem).attr("data-step");
    Interviews.interviews[interviewPos].vitalsNextClicked(stepPos);
  },

  retakeLimitExceeded: function retakeLimitExceeded(parentDiv) {
    var limitExceeded = false;
    $(".vitals-input", parentDiv).each(function () {
      var input = this;
      var val = $(this).val().replace(",", ".");
      var greater = $(input).attr('greater');
      var less = $(input).attr('less');
      if ($.isNumeric(val)) {
        if ($.isNumeric(less) && parseFloat(val) <= parseFloat(less) || $.isNumeric(greater) && parseFloat(val) >= parseFloat(greater)) {
          limitExceeded = true;
          return false; // stop loop
        }
      }
    });

    return limitExceeded;
  },
  hasSBPandDBP: function hasSBPandDBP(parentDiv) {
    var hasSBP = false;
    var hasDBP = false;
    parentDiv.each(function () {
      var val = $(this).val();
      var input_type = $(this).attr('name');
      if (input_type == "sbp" && val) {
        hasSBP = true;
      };
      if (input_type == "dbp" && val) {
        hasDBP = true;
      };
    });

    return hasSBP && hasDBP || !hasSBP && !hasDBP;
  },
  getComplexScheduleDateText: function getComplexScheduleDateText(reminderStart, reminderEnd, current_date) {
    var time_display_text = "";
    var start_text = reminderStart.format('%X');
    var end_time_text = reminderEnd.format('%X');

    if (current_date != undefined && false == moment(current_date).isSame(reminderStart, 'day')) {
      time_display_text = reminderStart.format('%x') + " " + start_text;
    } else {
      time_display_text = start_text;
    }

    if (current_date != undefined && false == moment(current_date).isSame(reminderEnd, 'day')) {
      time_display_text = time_display_text + " - " + reminderEnd.format('%x') + " " + end_time_text;
    } else if (current_date == undefined && false == moment(reminderStart).isSame(reminderEnd, 'day')) {
      time_display_text = time_display_text + " - " + reminderEnd.format('%x') + " " + end_time_text;
    } else {
      time_display_text = time_display_text + " - " + end_time_text;
    }

    return time_display_text;
  },

  getAllMeasurementDefinitions: function getAllMeasurementDefinitions() {
    var definitions = {};
    if (this.interviews) {
      $.each(this.interviews, function (i, interview) {
        $.each(interview.steps, function (j, step) {
          if (step.vitals) {
            $.each(step.vitals, function (k, vital) {
              definitions[vital.json.name] = vital.json;
            });
          }
        });
      });
    }

    return definitions;
  }

};